<template>
	<div class="rel">
		<!--head-->
		<div class="head-tit clear">
			<div class="w1200 clear">
				<p class="fr" style="color: #FF0000;">
					<img src="../assets/img/headphone-icon.png" /> 咨询热线：4009-303-555
				</p>
				<a :href="posLogin+'partner/jsp/loginagent.jsp'" target="_blank">代理商</a> <span class="fl">|</span>
				<a :href="person+'person'" target="_blank">个人</a>
				<a href="javascript:void(0)"><img src="../assets/img/IPv6.png" alt="" style="width: 35px;"></a>
			</div>
		</div>
		<el-header class="header" height="">
			<!---头部导航-->
			<div class="header-meun clear">
				<p class="fl"><a href="#/"><img src="../assets/img/logo.png" /></a></p>
				<el-menu class="meun fl el-menu-demo" :default-active="$route.path" mode="horizontal" @select="handleSelect">
					<el-menu-item index="/">
						<a href="#/">首页</a>
					</el-menu-item>
					<el-menu-item index="/about">
						<a href="#/about">关于我们</a>
					</el-menu-item>
					<el-menu-item index="/product">
						<a href="#/product">产品中心</a>
					</el-menu-item>
					<el-menu-item index="/news/news">
						<a href="#/news/news">新闻中心</a>
					</el-menu-item>	
					<el-menu-item index="/solve">
						<a href="#/solve">解决方案</a>
					</el-menu-item>
					<el-menu-item index="/cooperation">
						<a href="#/cooperation">商务合作</a>
					</el-menu-item>
					<el-menu-item index="/download">
						<a href="#/download">下载中心</a>
					</el-menu-item>
					<!-- <el-menu-item index="/openDoc">
						<router-link to="/openDoc" target="_blank">开放文档</router-link>
					</el-menu-item> -->
					<!-- <el-menu-item>
						<a :href="posLogin+'merchant/'" class="login-to"><img src="../assets/img/person-icon.png" />登录</a>
					</el-menu-item> -->
				</el-menu>
				<div class="login-step fr">
					<a :href="posLogin+'merchant/'" class="login-to"><img src="../assets/img/person-icon.png" />登录</a>
					<a :href="posLogin+'merchant/#/register'">注册</a>
				</div>
			</div>
		</el-header>
	</div>
</template>

<script>
	export default {
		data() {
			return{
				activeIndex: '1',
				//临时存放访问路径
				indexTemp: "1",
				posLogin: posLogin,
				person:person
			}
		},
		methods: {
			handleSelect(key, keyPath) {
				console.log(key, keyPath);
				if(key === "/productDoc"){
					//无需选中样式
					this.$router.push({ path: "/" });
					return false;
				} else {
					this.indexTemp = key;
				}
			}
		}
	}
</script>

<style lang="less">
	.el-dropdown-menu__item a {
		color: #333;
	}
	
	.head-tit {
		height: 30px;
		background-color: #eee;
		line-height: 30px;
		text-align: right;
		font-size: 12px;
		color: #605f5f;
		a {
			float: left;
			padding: 0 10px;
			color: #605f5f;
		}
		span {
			color: #c2bbc2;
		}
		img {
			vertical-align: middle;
		}
	}
	
	.header {
		position: absolute;
		top: 30px;
		left: 0;
		width: 100%;
		height: 80px;
		background: rgba(40, 68, 128, 0.37) !important;
		z-index: 9;
		.header-meun {
			width: 80%;
			margin: 0 auto;
			p>a img {
				padding-top: 25px;
				margin-right: 30px;
			}
			.meun {
				background: none;
				border-bottom: none;
				.el-menu-item {
					padding: 0px;
					height: 80px;
					width: 115px;
					line-height: 80px;
					color: #fff;
					font-size: 16px;
					text-align: center;
					border-bottom: none;
					.el-menu-item:not(.is-disabled):focus,
					.el-menu-item:not(.is-disabled):hover {
						color: #fff;
						background: #4d78dd;
					}
				}
				li a {
					display: block;
				}
				.is-active,
				li:hover {
					background: #4d78dd;
					color: #fff !important;
					border-bottom: none !important;
				}
			}
			.login-step {
				height: 40px;
				line-height: 40px;
				border: 1px #fff solid;
				border-radius: 10px;
				margin-top: 18px;
				color: #fff;
				padding: 0px 15px;
				a {
					display: inline-block;
					margin-right: 10px;
					font-size: 12px;
					color: #fff;
					text-align: center;
					line-height: 40px;
				}
				.login-to {
					padding-right: 10px;
					border-right: 1px #fff solid;
				}
				img {
					display: inline-block;
					margin-right: 10px;
					padding: 0px;
					vertical-align: text-bottom;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/head.vue